import React, { useState } from "react";
import DoriLogo from '../assets/img/dori_logo2_full_blue.png'
//import DemoImg from '../assets/img/card-3.jpeg';
//import DemoImg2 from '../assets/img/card-2.jpeg';
import OperationsMonitor1 from '../assets/img/operationsmonitor-image1.png';
import OperationsMonitor2 from '../assets/img/operationsmonitor-dashboard.png';
import ProcessAutomation1 from '../assets/img/processautomation-image1.png';
import ProcessAutomation2 from '../assets/img/processautomation-dashboard.png';
import QualityInspection1 from '../assets/img/qualityinspection-image1.png';
import QualityInspection2 from '../assets/img/qualityinspection-dashboard.png';
import KittingValidation1 from '../assets/img/kittingvalidation-image1.png';
import KittingValidation2 from '../assets/img/kittingvalidation-dashboard.png';

import './LoginSplashScreen.css';

const cardStyle = {
  margin: '0 0.5%',
  width: '20%',
//border: '2px solid #aaa',
  backgroundColor: 'white',
  padding: '10px 10px 40px 10px',
  borderRadius: '4px',
  cursor: 'pointer',
  textDecoration: 'none',
  boxShadow: "0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%)",
}

const cardFontStyle = {
  fontFamily: 'Lato',
  fontSize: '32px',
  textAlign: 'center',
  color: '#17B696',
  fontWeight: 400,
}

const LoginSplashScreen = () => {
  const [swapImageNo, setSwapImageNo] = useState(-1);

  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: '#eee', boxSizing: 'border-box' }}>
      <div style={{ backgroundColor: 'white', padding: '10px 96px' }}>
        <img src={DoriLogo} alt='logo' height='41px' />
      </div>
      <div style={{ width: '100%' }}>
        <h1 style={{fontFamily: 'Lato', fontSize: "40px", fontWeight: 400, width: '100%', textAlign: 'center', marginTop: '100px' }}>
          Welcome to Dori AI Vision
        </h1>
        <h3 style={{ color: 'gray', fontWeight: '400', fontSize: '22px', width: '100%', textAlign: 'center' }}>
          Please select an application to proceed
        </h3>

        <div style={{ width: '100%', marginTop: '40px', display: 'flex', justifyContent: 'center' }}>
          <a href="https://vision-monitor.doriai.com" style={cardStyle}>
            <div className="container">
              <img src={OperationsMonitor1} alt="Avatar" className="image" />
              <div className="overlay">
                <img src={OperationsMonitor2} alt="Avatar" className="text" />
              </div>
            </div>
            <div style={cardFontStyle}>
              <div style={{ height: '30px', marginTop: '20px' }}>Operations</div>
              <div style={{ height: '30px' }}>Monitor</div>
            </div>
          </a>


          <a href="https://vision-automate.doriai.com" style={cardStyle}>
            <div className="container">
              <img src={ProcessAutomation1} alt="Avatar" className="image" />
              <div className="overlay">
                <img src={ProcessAutomation2} alt="Avatar" className="text" />
              </div>
            </div>
            <div style={cardFontStyle}>
              <div style={{ height: '30px', marginTop: '20px' }}>Process</div>
              <div style={{ height: '30px' }}>Automation</div>
            </div>
          </a>

          <a href="https://vision-inspect.doriai.com" style={cardStyle}>
            <div className="container">
              <img src={QualityInspection1} alt="Avatar" className="image" />
              <div className="overlay">
                <img src={QualityInspection2} alt="Avatar" className="text" />
              </div>
            </div>
            <div style={cardFontStyle}>
              <div style={{ height: '30px', marginTop: '20px' }}>Quality</div>
              <div style={{ height: '30px' }}>Inspection</div>
            </div>
          </a>

          <a href="https://vision-kit.doriai.com" style={cardStyle}>
            <div className="container">
              <img src={KittingValidation1} alt="Avatar" className="image" />
              <div className="overlay">
                <img src={KittingValidation2} alt="Avatar" className="text" />
              </div>
            </div>
            <div style={cardFontStyle}>
              <div style={{ height: '30px', marginTop: '20px' }}>Kitting</div>
              <div style={{ height: '30px' }}>Validation</div>
            </div>
          </a>
        </div>
      </div>

    </div>
  );
}

export default LoginSplashScreen;